<template>
  <div class="box-step-puzzle">
    <ul class="step-puzzle__list">
      <li
        v-for="(step, index) in steps"
        :key="index"
        @click="$emit('click', { index, step })"
        :class="{
          selected: step.id == stepUserIs,
          'left-arrow': index > 0,
          'step-ok': step.id < stepUserIs,
        }"
      >
        <p class="step-puzzle__number">
          <span>{{ step.number }}</span>
          <span class="step-puzzle__text" :id="step.text.replace(/ /g, '-')">{{ step.text }}</span>
        </p>
      </li>
    </ul>
  </div>
</template>

<script lang="js">
export default {
  name: "JNSStepPuzzle",
  props: {
    stepUserIs: {
      default: false,
    },  
    steps: {
      default: false,
    },  
    noNavegation: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    stepPuzzleClasses () {
      return {
        'step-puzzle__list': true,
        'step-puzzle__list--no-navegation': this.noNavegation,
      }
    }
  }
};
</script>

<style lang='scss' scoped>
#jns {
  .box-step-puzzle {
    width: 100%;
    overflow: hidden;
  }

  @media screen and (max-width: 721px) {
    .step-puzzle__list {
      li {
        &:not(.selected) {
          display: none;
        }
      }

      li.selected + li {
        display: flex;
      }
    }
  }

  @media screen and (max-width: 521px) {
    .step-puzzle__list {
      li {
        &:not(.selected) {
          display: none;
        }
      }

      li.selected + li {
        display: none;
      }
    }
  }

  .step-ok {
    background-color: #dfdfdf !important;

    &::after {
      border-left: 30px solid #dfdfdf !important;
    }
  }

  .step-puzzle__number {
    font-size: 17px;
    font-weight: bold;
    color: #a5a5a5;
    margin-bottom: 0;
    padding-left: 10px;
    display: flex;
    align-items: center;
    overflow: hidden;

    .step-puzzle__text {
      margin: 0 0 0 5px !important;
    }
  }

  .step-puzzle__list {
    position: relative;
    display: flex;
    padding-right: 30px;
    padding-left: 0;
    align-items: center;

    .step-puzzle__text {
      font-size: 14px;
      color: #a5a5a5;
      margin-top: -5px;
      font-weight: bold;
    }

    li {
      flex: 1;
      display: inline-block;
      height: 54px;
      background-color: white;
      position: relative;
      min-width: 150px;
      padding: 12px 5px 15px 32px;
      margin-right: 10px;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: pointer;

      &.selected {
        background-color: #282498;
        .step-puzzle__number {
          color: #fff;
        }
        .step-puzzle__text {
          color: #fff;
        }
      }

      &:after {
        content: "";
        z-index: 2;
        position: absolute;
        right: -30px;
        top: 0;
        border-left: 30px solid white;
        border-top: 27px solid transparent;
        border-bottom: 27px solid transparent;
      }

      &.selected:after {
        border-left: 30px solid #282498;
      }

      &.left-arrow:before {
        content: "";
        position: absolute;
        left: 0px;
        top: 0;
        border-left: 30px solid #f5f5f5;
        border-top: 27px solid transparent;
        border-bottom: 27px solid transparent;
      }

      &.selected.left-arrow:before {
        right: -30px;
      }
    }
  }
  .step-puzzle__number {
    font-size: 22px;
    font-weight: bold;
    color: #a5a5a5;
  }

  .step-puzzle__text {
    font-size: 14px;
    color: #a5a5a5;
    margin-top: -5px;
    font-weight: bold;
  }
}
</style>	



// WEBPACK FOOTER //
// ./src/components/JNSStepPuzzle.vue